
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class CopyButton extends Component {

  handleOnClick(e) {
    const { disabled, copyTarget, onError } = this.props;
    if (!disabled && copyTarget) {
      var copyNode = document.querySelector("#"+copyTarget);

      var range = document.createRange();
      range.selectNode(copyNode);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);

      try {
        document.execCommand('copy');
      }
      catch(err) {
        onError(err);
      }

      window.getSelection().removeAllRanges();
    }
  }

  render() {
    const { id, text, disabled } = this.props;

    return (
      <button
        id={id}
        disabled={!!disabled}
        onClick={e => this.handleOnClick(e)}
        className="btn btn-default">
        {text || 'Copy'}
      </button>
    );
  }
}

CopyButton.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  copyTarget: PropTypes.string,
  onError: PropTypes.func,
}

export default CopyButton;
